// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 598) return "598_vendors.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"ca89acc0","452":"3450605f"}[chunkId] + ".chunk.js";
};